import {CreditClass} from 'app/blocks/model/credit-class.model';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Resource} from 'app/constants/resource';
import {ICreditClass} from 'app/blocks/model/credit-class.model';
import EntityCrudService from 'app/blocks/service/api/entity-service';

@Injectable({
    providedIn: 'root'
})
export class CreditClassService extends EntityCrudService<ICreditClass> {
    constructor(http: HttpClient) {
        super(http, Resource.CREDIT_CLASSES, (obj?) => new CreditClass(obj));
    }
}
